import routeHelper from '../components/common/classes/routeHelper';
import { getStorage } from '../utils/storage';
import store from '../reducers/storeRegistration';
import annotationActions from '../actions/annotationActionCreators';
import formActions from '../actions/formActionCreators';
import notificationActions from '../actions/notificationActionCreators';
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  // Evaluate required source properties
  const remotePath = await sourceEvaluator(source.remotePath);
  if (remotePath === undefined) return;
  const title = await sourceEvaluator(source.editorTitle);

  // Evaluate optional source properties
  const renderReadonly = (await sourceEvaluator(source.renderReadonly)) || false;
  const toolbar = (await sourceEvaluator(source.toolbar)) || {};
  const annotationHandler = (await sourceEvaluator(source.annotationHandler)) || {};
  const filters = (await sourceEvaluator(source.filters)) || {};

  // Create editor state object
  const editorState = {
    remotePath,
    title,
    toolbar,
    renderReadonly,
    filters,
    annotationHandler,
    parent: {
      // passing all of parent content since the annotationHandler methods may need it
      // this will need further attention in the cabinet to annotation case, perhaps
      // changing the implementation to automatically load the parent
      content,
      contentPath: parentContentPath
    }
  };

  // Store editor state in localStorage and Redux (similar to setEditorState action)
  const storage = getStorage(JSON.parse(global.localStorage.getItem('user')));
  storage.setItem('annotationEditorState', JSON.stringify(editorState));

  // Dispatch Redux action
  await store.dispatch(annotationActions.setEditorState(editorState));

  // Check for pending changes before navigating
  const currentState = store.getState();
  const formState = currentState.form;
  if (formState && formState.pendingChanges) {
    // Show notification requiring save before proceeding to edit PDF
    // This applies to both new and existing forms to ensure data integrity
    const saveAndNavigate = async () => {
      try {
        await store.dispatch(formActions.serverSave());
        routeHelper.updateURL('/annotations');
      } catch (_unused) {
        store.dispatch(notificationActions.error({
          headerMessage: 'Save Failed',
          message: 'Failed to save form before navigation. Please try again.',
          messageType: 'error'
        }));
      }
    };
    store.dispatch(notificationActions.info({
      headerMessage: 'You have unsaved changes.',
      message: 'You must save before loading the PDF.',
      messageType: 'info',
      rightButtonLabel: 'Save & Continue',
      leftButtonLabel: 'Cancel',
      rightButtonAction: saveAndNavigate,
      leftButtonAction: () => {
        // Just close the notification, don't navigate
      }
    }, {
      autoClose: false
    }));
  } else {
    // No pending changes, proceed with navigation
    routeHelper.updateURL('/annotations');
  }
};
export default {
  evaluate
};